import Image from 'next/image';
import styled from 'styled-components';

function MapIcons() {
  return (
    <Wrapper>
      <SectionWrapper>
        <Image
          width={18}
          height={23}
          alt="location-icon.svg"
          src="icons/location-icon.svg"
          loading="lazy"
        />

        <StyledDescription>Our Terminals</StyledDescription>
      </SectionWrapper>

      <SectionWrapper>
        <Image
          width={30}
          height={30}
          loading="lazy"
          alt="location-radius.svg"
          src="icons/location-radius.svg"
        />

        <StyledDescription>Pickup Radius (100 miles)</StyledDescription>
      </SectionWrapper>

      <SectionWrapper>
        <Image
          width={16}
          height={16}
          loading="lazy"
          alt="pickup-radius.svg"
          src="icons/pickup-radius.svg"
        />

        <StyledDescription>Pickup Radius (50 miles)</StyledDescription>
      </SectionWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;

  width: 100%;
  height: 36px;
  max-width: 680px;
  margin: 20px auto;

  justify-content: space-between;
`;

const SectionWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 32%;
`;

const StyledDescription = styled.div`
  margin-left: 5px;

  font-size: 12px;
  line-height: 15px;

  color: ${({ theme }) => theme.colors.textPrimary};
`;

export default MapIcons;
